<template>
  <div class="todoItemTemplate">
    <button
      class="floatButton"
      @click="showTemplates = !showTemplates"
      v-if="hasSimplePermissions('addTodoItemsFromTemplate') || hasSimplePermissions('addTodoTemplateFromItems')"
    >
      <b-icon icon="post-add" />
    </button>
    <div v-if="showTemplates && hasSimplePermissions('addTodoItemsFromTemplate')">
      <multiselect
        class="boon-multiselect"
        :custom-label="(p) => p.title"
        :selectLabel="$t('Add New')"
        :multiple="false"
        :options="currentProjectActiveTodoTemplates"
        :placeholder="$t('Add from template')"
        @input="addFromTemplate($event)"
        id="todoTemplate"
      >
        <div slot="noResult">{{ $t('No templates found') }}</div>
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <div class="option__title">
              {{ props.option.title }}
            </div>
            <span class="option__small" v-for="(itm, idx) in filterActive(props.option.todoTemplates)" :key="idx">
              {{ itm.title + (idx < filterActive(props.option.todoTemplates).length ? ',' : '') }}
            </span>
          </div>
        </template>
      </multiselect>
      <div v-if="selectedPartTodoItems.length > 0 && hasSimplePermissions('addTodoTemplateFromItems')">
        {{ $t('Create template from these items') }}
        <input type="text" v-model="templateTitle" :placeholder="$t('Title of template')" size="10" />
        <button @click="addTemplateFromItems" class="darkButton">{{ $t('Add') }}</button>
      </div>
      <br />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import { EventBus } from '@/common/eventbus';

export default {
  name: 'TodoItemTemplate',
  props: ['part'],
  data: function () {
    return {
      showTemplates: false,
      templateTitle: '',
    };
  },
  methods: {
    ...mapActions(['addTodoItemsFromTemplate', 'addTodoTemplateFromItems']),
    addFromTemplate: function (tpl) {
      this.addTodoItemsFromTemplate({ projectId: this.part.projectId, templateId: tpl._id, partId: this.part._id });
      this.showTemplates = false;
    },
    addTemplateFromItems: function () {
      this.addTodoTemplateFromItems({
        projectId: this.part.projectId,
        partId: this.part._id,
        newTodoTemplateProperties: { title: this.templateTitle },
      }).then((newTpl) => {
        EventBus.$emit('showMessageToUser', {
          message: 'Template {title} was added',
          title: newTpl.title,
          type: 'info',
          duration: 5000,
        });
      });
      this.templateTitle = '';
    },
    filterActive: function (list) {
      return list.filter((i) => !i.archived);
    },
  },
  computed: {
    ...mapGetters(['hasSimplePermissions', 'currentProjectActiveTodoTemplates', 'selectedPartTodoItems']),
  },
  mounted: function () {
    this.showTemplates = this.selectedPartTodoItems.length === 0;
  },
  filters: {},
  components: {
    Multiselect,
  },
};
</script>

<style scoped>
.floatButton {
  color: black;
  float: right;
}
input {
  border-bottom: 1px dotted black;
}
.option__small {
  font-size: 50%;
}
.boon-multiselect {
  margin-bottom: 5mm;
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/TodoItemTemplate.vue